import axios from "axios";
import { base_url, key } from "../config/VariableComponents";

export default {
  route: {
    get: {
      menus: "get/menus",
      page: "get/page/single",
      assurance: "get/assurance",
      assurance_detail: "get/assurance/detail",
      banner: "get/banner",
      facility: "get/facility",
      videos: "get/videos",
      articles: "get/article",
      article: "get/article-single",
      doctors: "get/doctors",
      doctor: "get/doctor",
      careers: "get/careers",
      gallery: "get/gallery",
      promotion: "get/promotion"
    },
    post: {
      login: "get/user/login",
      register: "get/user/register",
      verify: "get/user/verify",
      resend: "get/user/resend",
      contact: "get/send/email"
    }
  },
  post: (url, params = {}) => {
    return axios.post(base_url + url + "?key=" + key, params).then(r => r.data);
  },
  get: url => {
    return axios.get(base_url + url + "?key=" + key).then(r => r.data);
  }
};



// WEBPACK FOOTER //
// ./src/services/api.js